import { useSearchParams } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { usePermissions } from "@/lib/permissions";
import Snags from "@/pages/project/quality/Snags";
import Drawings from "@/pages/project/quality/Drawings";
import Handover from "@/pages/project/quality/Handover";

/** One module for what the site checks and hands over: snags, the drawing register, and handover with warranties and the final account. */
export default function QualityHandover() {
  const { can } = usePermissions();
  const [params, setParams] = useSearchParams();
  const tabs = [
    can("SNAGS", "view") && { id: "snags", label: "Snags", node: <Snags /> },
    can("DRAWING_REGISTER", "view") && { id: "drawings", label: "Drawing register", node: <Drawings /> },
    can("HANDOVER", "view") && { id: "handover", label: "Handover & warranties", node: <Handover /> },
  ].filter(Boolean);
  const wanted = params.get("tab");
  const tab = tabs.find((t) => t.id === wanted)?.id || tabs[0]?.id;
  return (
    <div className="space-y-5" data-testid="quality-page">
      <PageHeader title="Quality & Handover" description="Defects found on site, the drawing register, and what is handed over to the client: warranties and the final account." />
      {tabs.length === 0 ? <p className="text-sm text-muted-foreground" data-testid="quality-no-access">You do not have access to any part of this page.</p> : (
        <Tabs value={tab} onValueChange={(t) => setParams(t === tabs[0].id ? {} : { tab: t }, { replace: true })}>
          <TabsList>{tabs.map((t) => <TabsTrigger key={t.id} value={t.id} data-testid={`quality-tab-${t.id}`}>{t.label}</TabsTrigger>)}</TabsList>
          {tabs.map((t) => <TabsContent key={t.id} value={t.id}>{t.node}</TabsContent>)}
        </Tabs>)}
    </div>
  );
}
